<template>
    <v-dialog v-model="dialog" max-width="800px"> 
        <v-btn v-if="edit" fab dark small color="green" slot="activator">
            <v-icon dark>edit</v-icon>
        </v-btn>
        <v-btn v-else fab dark small depressed slot="activator" class="primary">
            <v-icon dark>add</v-icon>
        </v-btn>

        <v-card>
            <v-card-title>
                <h2 v-if="edit">Edit Client</h2>
                <h2 v-else>Create a New Client</h2>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    >
                    <v-layout wrap>

                        <v-flex xs12>
                            <v-text-field 
                                v-model="name" 
                                label="Name"
                                :rules="nameRules" 
                                required>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat @click="dialog = false">Cancel</v-btn>
                <v-btn v-if="edit" :disabled="!valid" color="primary" flat @click="_updateClient">Update</v-btn>
                <v-btn v-else :disabled="!valid" color="primary" flat @click="_createClient">Create</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
        data(){
            return{
                dialog : false,
                valid: true,
                name: this.clientName || '',
                nameRules: [
                    v => !!v || 'Name is required',
                ],
            }
        },
        methods: {
            ...mapActions([
                'createClient',
                'updateClient'
            ]),
            _createClient(){  
                // if form is valid
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                    console.log(`_createClient name: ${this.name}`)
                    // adding user to collection returns a reference to the user document
                    this.createClient({
                    name:this.name,
                    })
                    .then(()=>{
                        // after creation, close create user dialog
                        this.dialog = false
                    })
                }
            },
            _updateClient(){
                // if form is valid
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                    console.log(`_updateClient name: ${this.name}`)
                    // adding user to collection returns a reference to the user document
                    this.updateClient({
                        name: this.name,
                        id: this.edit
                    })
                    .then(()=>{
                        // after creation, close create user dialog
                        this.dialog = false
                    })
                }
            }
        },
        props: ['edit', 'clientName']
}
</script>